/**
 * Curated executive points of view — primarily LinkedIn posts.
 * Update when new POVs are published.
 */
export const linkedInPointOfViews = [
  {
    id: 'ai-enterprise-governance',
    title: 'AI Now Answers To Enterprise Governance',
    excerpt:
      'AI is entering enterprise decision-making, operations, risk, and capital allocation. The executive question is ownership, funding, stop authority, and evidence to scale. The Shared Oxygen Strategic Capability And Control Map frames that conversation with discipline.',
    url: 'https://www.linkedin.com/posts/activity-7457123073742295040-T0yf',
    publishedDate: '2026-05-06',
    imageUrl: '/images/shared-oxygen-linkedin.png',
    imageAlt: 'AI Now Answers To Enterprise Governance — Strategic Capability And Control Map',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
  {
    id: 'tokens-strategic-imperative',
    title: 'The Rise Of Tokens As A Strategic Imperative',
    excerpt:
      'Tokens are becoming a balance-sheet line item alongside payroll. Engineer costs rose 40% over a decade while advanced model token prices collapsed by up to 900x annually—reshaping budget allocation, workforce strategy, and competitive position for executive teams.',
    url: 'https://www.linkedin.com/posts/sharedoxygen_the-rise-of-tokens-as-a-strategic-imperative-ugcPost-7452760217005576192-XZdQ/',
    publishedDate: '2026-04-28',
    imageUrl: '/images/tokens-strategic-imperative-linkedin.svg',
    imageAlt: 'The Rise Of Tokens As A Strategic Imperative — Shared Oxygen executive brief',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
];
